export default "__VITE_ASSET__c3904f3e__"